"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "2.33.0", "build_date": "2021-12-13T15:19:37.510Z", "build_branch": "2.33.0", "build_commit": "584f082ad3cf1b918e1ca395aa3c6da628e81ce0" };
